import ProductPriceTable from '../includes/product-price-table';

hp(window).on('load', () => {
    new ProductPriceTable('#cpanel-table')
    new ProductPriceTable('#ispmanager-table')
})
